<template>
  <validation-observer ref="simpleRules">
    <b-form
      method="POST"
      class="auth-reset-password-form mt-2"
      @submit.prevent="validationForm"
    >
      <!-- password -->
      <b-form-group
        label="Current Password"
        label-for="reset-password-new"
        v-if="$route.name == 'users-edit-profile'"
      >
        <validation-provider
          #default="{ errors }"
          name="Current Password"
          vid="CurrentPassword"
          rules="required|min:8|password"
        >
          <b-input-group
            class="input-group-merge"
            :class="errors.length > 0 ? 'is-invalid' : null"
          >
            <b-form-input
              id="reset-password-new"
              v-model="current_password"
              :type="password3FieldType"
              :state="errors.length > 0 ? false : null"
              class="form-control-merge"
              name="reset-password-new"
              placeholder="············"
              autocomplete="on"
            />
            <b-input-group-append is-text>
              <feather-icon
                class="cursor-pointer"
                :icon="password3ToggleIcon"
                @click="togglePassword3Visibility"
              />
            </b-input-group-append>
          </b-input-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
      <b-form-group label="New Password" label-for="reset-password-new">
        <validation-provider
          #default="{ errors }"
          name="Password"
          vid="Password"
          rules="required|min:8|password"
        >
          <b-input-group
            class="input-group-merge"
            :class="errors.length > 0 ? 'is-invalid' : null"
          >
            <b-form-input
              id="reset-password-new"
              v-model="password"
              :type="password1FieldType"
              :state="errors.length > 0 ? false : null"
              class="form-control-merge"
              name="reset-password-new"
              placeholder="············"
              autocomplete="on"
            />
            <b-input-group-append is-text>
              <feather-icon
                class="cursor-pointer"
                :icon="password1ToggleIcon"
                @click="togglePassword1Visibility"
              />
            </b-input-group-append>
          </b-input-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <!-- confirm password -->
      <b-form-group label-for="reset-password-confirm" label="Confirm Password">
        <validation-provider
          #default="{ errors }"
          name="Confirm Password"
          :rules="`required|min:8|confirmed:${password}`"
        >
          <b-input-group
            class="input-group-merge"
            :class="errors.length > 0 ? 'is-invalid' : null"
          >
            <b-form-input
              id="reset-password-confirm"
              v-model="cPassword"
              :type="password2FieldType"
              class="form-control-merge"
              :state="errors.length > 0 ? false : null"
              name="reset-password-confirm"
              placeholder="············"
              autocomplete="on"
            />
            <b-input-group-append is-text>
              <feather-icon
                class="cursor-pointer"
                :icon="password2ToggleIcon"
                @click="togglePassword2Visibility"
              />
            </b-input-group-append>
          </b-input-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <!-- submit button -->
      <b-button block type="submit" class="gradient-btn" >
        Set New Password
      </b-button>
    </b-form>
    <loader :loading="loading" />
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BForm,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BFormInput,
  BButton,
} from "bootstrap-vue";
import { required } from "@validations";
import Loader from "@/@core/components/loader/Loader.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BInputGroup,
    BLink,
    BFormInput,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    Loader,
  },
  data() {
    return {
      cPassword: "",
      password: "",
      current_password: "",
      loading: false,
      // validation
      required,

      // Toggle Password
      password1FieldType: "password",
      password2FieldType: "password",
      password3FieldType: "password",
    };
  },
  computed: {
    password1ToggleIcon() {
      return this.password1FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password2ToggleIcon() {
      return this.password2FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password3ToggleIcon() {
      return this.password3FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  methods: {
    togglePassword1Visibility() {
      this.password1FieldType =
        this.password1FieldType === "password" ? "text" : "password";
    },
    togglePassword2Visibility() {
      this.password2FieldType =
        this.password2FieldType === "password" ? "text" : "password";
    },
    togglePassword3Visibility() {
      this.password3FieldType =
        this.password3FieldType === "password" ? "text" : "password";
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            let newObject = {
              password: this.password,
              password_confirmation: this.cPassword,
            };
            this.current_password &&
              (newObject.current_password = this.current_password);
            const { data } = await this.$http.patch(
              this.$route.name == "users-edit-profile"
                ? "panel/profile/user/password"
                : `panel/users/${this.$route.params.id}/password`,
              {
                ...newObject,
              }
            );

            this.$emit("closeShowChangePassword");
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `Password changed successfully`,
                icon: "CoffeeIcon",
                variant: "success",
              },
            });
          } catch (err) {}
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style></style>
